module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticClass: "OfficeAdd"
  }, [_c('div', {
    staticClass: "header header-mobile"
  }, [_c('aside', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle active"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.tabs.address.title))])]), _vm._v(" "), _c('aside', {
    staticClass: "navigation"
  }), _vm._v(" "), _c('aside', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle",
    class: {
      active: _vm.steps.two.active || _vm.steps.three.active || _vm.steps.four.active
    }
  }), _vm._v(" "), _c('span', {
    class: {
      active: _vm.steps.two.active || _vm.steps.three.active || _vm.steps.four.active
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.tabs.start_date.title))])]), _vm._v(" "), _c('aside', {
    staticClass: "navigation"
  }), _vm._v(" "), _c('aside', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle",
    class: {
      active: _vm.steps.three.active || _vm.steps.four.active
    }
  }), _vm._v(" "), _c('span', {
    class: {
      active: _vm.steps.three.active || _vm.steps.four.active
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.tabs.end_date.title))])]), _vm._v(" "), _c('aside', {
    staticClass: "navigation"
  }), _vm._v(" "), _c('aside', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle",
    class: {
      active: _vm.steps.four.active
    }
  }), _vm._v(" "), _c('span', {
    class: {
      active: _vm.steps.four.active
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.tabs.reason.title))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.steps.one.active) ? _c('div', [_c('header', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.tabs.address.subtitle))])]), _vm._v(" "), _c('main', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.office.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.fields.office))]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "office",
      "id": "office"
    },
    model: {
      value: (_vm.data.office),
      callback: function($$v) {
        _vm.data.office = $$v
      },
      expression: "data.office"
    }
  }, _vm._l((_vm.offices), function(office) {
    return _c('md-option', {
      key: office.id,
      attrs: {
        "value": office.id
      }
    }, [_vm._v(_vm._s(office.name))])
  })), _vm._v(" "), (_vm.errors.office.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.office.msg))]) : _vm._e()], 1)], 1)], 1)], 1)]) : (_vm.steps.two.active) ? _c('div', [_c('header', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.tabs.start_date.subtitle))])]), _vm._v(" "), _c('main', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "amolpicker container-date",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.fields.start_date))]), _vm._v(" "), _c('md-icon', {
    staticClass: "icon-calendar"
  }, [_vm._v("today")]), _vm._v(" "), _c('date-picker', {
    staticClass: "picker",
    attrs: {
      "option": _vm.option,
      "limit": _vm.limit,
      "date": _vm.startDate
    },
    model: {
      value: (_vm.data.start_date),
      callback: function($$v) {
        _vm.data.start_date = $$v
      },
      expression: "data.start_date"
    }
  }), _vm._v(" "), (_vm.errors.start_date.invalid) ? _c('small', {
    staticClass: "small-error"
  }, [_vm._v(_vm._s(_vm.errors.start_date.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amoltimer",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.fields.start_time))]), _vm._v(" "), _c('md-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('vue-timepicker', {
    staticClass: "timer",
    attrs: {
      "format": "HH:mm"
    },
    on: {
      "change": function($event) {
        _vm.updateTime($event, 'start_time')
      }
    },
    model: {
      value: (_vm.data.start_time_value),
      callback: function($$v) {
        _vm.data.start_time_value = $$v
      },
      expression: "data.start_time_value"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-error"
  }, [_vm._v(_vm._s(_vm.errors.start_time.msg))])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-checkbox', {
    staticClass: "checkbox-list md-primary",
    attrs: {
      "md-theme": "green",
      "id": "interval",
      "name": "interval"
    },
    model: {
      value: (_vm.data.interval),
      callback: function($$v) {
        _vm.data.interval = $$v
      },
      expression: "data.interval"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.fields.extrahour_in_intervals))]), _vm._v(" "), _c('span', {
    staticClass: "color_form_placeholder normal"
  }, [_vm._v("    " + _vm._s(_vm.translate.pages.extrahours.add.fields.extrahour_in_intervals_description))])])], 1)], 1)], 1)]) : (_vm.steps.three.active) ? _c('div', [_c('header', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.tabs.end_date.subtitle))])]), _vm._v(" "), _c('main', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "amolpicker container-date",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.fields.end_date))]), _vm._v(" "), _c('md-icon', {
    staticClass: "icon-calendar"
  }, [_vm._v("today")]), _vm._v(" "), _c('date-picker', {
    staticClass: "picker",
    attrs: {
      "option": _vm.option,
      "limit": _vm.limit,
      "date": _vm.endDate
    },
    model: {
      value: (_vm.data.end_date),
      callback: function($$v) {
        _vm.data.end_date = $$v
      },
      expression: "data.end_date"
    }
  }), _vm._v(" "), (_vm.errors.end_date.invalid) ? _c('small', {
    staticClass: "small-error"
  }, [_vm._v(_vm._s(_vm.errors.end_date.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "amoltimer",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.fields.end_time))]), _vm._v(" "), _c('md-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('vue-timepicker', {
    staticClass: "timer",
    attrs: {
      "format": "HH:mm"
    },
    on: {
      "change": function($event) {
        _vm.updateTime($event, 'end_time')
      }
    },
    model: {
      value: (_vm.data.end_time_value),
      callback: function($$v) {
        _vm.data.end_time_value = $$v
      },
      expression: "data.end_time_value"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-error"
  }, [_vm._v(_vm._s(_vm.errors.end_time.msg))])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container checkbox-list",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "md-theme": "green",
      "id": "interval",
      "name": "interval"
    },
    model: {
      value: (_vm.data.interval),
      callback: function($$v) {
        _vm.data.interval = $$v
      },
      expression: "data.interval"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.fields.extrahour_in_intervals))]), _vm._v(" "), _c('span', {
    staticClass: "color_form_placeholder normal"
  }, [_vm._v("    " + _vm._s(_vm.translate.pages.extrahours.add.fields.extrahour_in_intervals_description))])])], 1)], 1)], 1)]) : _c('div', [_c('header', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.tabs.reason.subtitle))])]), _vm._v(" "), _c('main', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.reason.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.fields.reason))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.data.reason),
      callback: function($$v) {
        _vm.data.reason = $$v
      },
      expression: "data.reason"
    }
  }), _vm._v(" "), (_vm.errors.reason.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.reason.msg))]) : _vm._e()], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "content-footer"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "buttons clearfix"
  }, [_c('div', {
    staticClass: "return"
  }, [_c('md-button', {
    staticClass: "md-raised md-size btn--gray",
    attrs: {
      "disabled": _vm.steps.button
    },
    nativeOn: {
      "click": function($event) {
        _vm.previous($event)
      }
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" " + _vm._s(_vm.translate.pages.extrahours.add.buttons.previous))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-size btn--blue",
    attrs: {
      "disabled": _vm.process
    },
    nativeOn: {
      "click": function($event) {
        _vm.next($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.extrahours.add.buttons.next) + " "), _c('md-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d6b6378"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/ExtraHours/Add.vue
// module id = 659
// module chunks = 1